import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(
    private readonly injector: Injector,
    private readonly ngZone: NgZone
  ) {}
  private get toaster() {
    return this.injector.get(ToastService);
  }

  handleError(error: any): void {
    console.error('Error Message:' + error?.error?.Message);
    console.error(error);
    this.ngZone.runOutsideAngular(() => {
      this.toaster.error("Houston, we've got a problem. Please contact Customer Support...", 'System Error');
    });
  }
}
